import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";

var unwrap = function unwrap(props, method) {
  return typeof method === 'function' ? method(props) : method;
};

export default function ModuleHOC(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$tagName = _ref.tagName,
      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
      _ref$render = _ref.render,
      render = _ref$render === void 0 ? null : _ref$render;

  function Module(props) {
    var TagName = unwrap(props, tagName) || 'div';
    return ___EmotionJSX(TagName, _extends({
      id: props.name,
      className: props.className,
      style: props.style
    }, process.env.ENV_RAW ? null : props.uiEvents), render ? render(props) : null, props.children);
  }

  Module.className = className;
  return Module;
}